import type { IconSvgObject } from './types';

const ToyBrickIcon: IconSvgObject = [
  ["path", { d: "M2 18V10C2 8.89543 2.89543 8 4 8H20C21.1046 8 22 8.89543 22 10V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 8V5C5 4.44772 5.44772 4 6 4H9C9.55228 4 10 4.44772 10 5V8H5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 8V5C14 4.44772 14.4477 4 15 4H18C18.5523 4 19 4.44772 19 5V8H14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ToyBrickIcon;
